import React, { useCallback } from 'react'
import { ModalBody } from 'reactstrap'
import { BasicHeader } from '@/dialogs/common/basicHeader'
import { GridColumn as Column } from '@progress/kendo-react-grid'
import { CloseFooter } from '@/dialogs/common/closeFooter'
import { BsrsGrid, EnumCellStatus, EnumFilterCell } from '@/components/BsrsGrid'
import { useLocalization } from '@/hooks/localization'
import { logSeverity } from '@/enums/logSeverity'
import Resx from '@/components/Resx'
import { Button } from '@/components/button'
import fileDownload from 'js-file-download'
import getEnumTranslation from '@/enums/enums'
import { Link } from 'react-router-dom'

function BgJobMessagesDialog (props) {
  const { backgroundJobMessages } = props
  const { localize, localizeValue } = useLocalization()
  const messages = backgroundJobMessages.map(m => { return { ...m, message: localizeValue(m.message, m.latinMessage) } })

  const downloadLogs = useCallback(() => {
    const transformed = messages.map(x => `[${getEnumTranslation({
      localize,
      enumName: logSeverity.enumName,
      value: x.severity
    })}] ${x.message}`)

    fileDownload(transformed.join('\n'), 'messages.txt', 'text/plain')
  }, [localize, messages])

  const message = ({ dataItem }) => {
    let value = <pre style={{ whiteSpace: 'pre-line' }}>{dataItem.message}</pre>

    if (dataItem.url) value = <Link to={dataItem.url}>{value}</Link>

    return value
  }

  return <React.Fragment><BasicHeader title='Common.BgJobMessages' {...props} />
    <ModalBody {...props}>
      <BsrsGrid items={messages} simpleView>
        <Column cell={message} title={localize('Common.Message')} />
        <Column filter='text' field='severity' title={localize('Common.Severity')}
          cell={EnumCellStatus({ localize, enumName: logSeverity.enumName, visualStatus: bgMessageErrorSeverity })}
          filterCell={EnumFilterCell({ localize, enumName: logSeverity.enumName }, logSeverity.values)}
          enumName={logSeverity.enumName} width={150} />
        <Column width='50px' field='occurrences' title={localize('Common.OccurrencesAbbreviated')} />
      </BsrsGrid>
      <hr />
      <Button icon='download' onClick={downloadLogs}><Resx name={'Common.Download'} /></Button>
    </ModalBody>
    <CloseFooter btnColor='secondary' {...props} />
  </React.Fragment>
}

function bgMessageErrorSeverity (statusNumber) {
  switch (statusNumber) {
    case 0: return 'debug'
    case 1: return 'info'
    case 2: return 'warning'
    case 3: return 'error'
    case 4: return 'fatal'
  }
  return 'info'
}

export default {
  modalProps: {
    className: 'modal-dialog--lg'
  },
  component: BgJobMessagesDialog
}



// WEBPACK FOOTER //
// ./src/dialogs/bgJobMessages.js